/* unplugin-vue-components disabled */import script from "./WjCOnfig.vue?vue&type=script&setup=true&lang=js"
export * from "./WjCOnfig.vue?vue&type=script&setup=true&lang=js"

import "./WjCOnfig.vue?vue&type=style&index=0&id=59077d9a&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59077d9a"]])

export default __exports__